import React, { FC } from "react";
import { createPortal } from "react-dom";
import "./styles.less";
import { getImgSrc } from "@/utils";

export const WechatDownloadModal: FC<{ visible: boolean }> = ({ visible }) => {
  const mask = (
    <>
      <div className="authing-wenchat-guide-modal-mask" />
      <img
        alt="Wechat Download"
        style={{
          width: "80%",
          zIndex: 1001,
          objectFit: "contain",
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          margin: "0 auto",
          marginTop: 12,
        }}
        src={getImgSrc("/wechat-download-guide.png")}
      />
    </>
  );
  return visible ? createPortal(mask, document.body) : null;
};
